import { render, staticRenderFns } from "./ReferralsViewDetails.vue?vue&type=template&id=1a92ac5a&scoped=true"
import script from "./ReferralsViewDetails.vue?vue&type=script&lang=js"
export * from "./ReferralsViewDetails.vue?vue&type=script&lang=js"
import style0 from "./ReferralsViewDetails.vue?vue&type=style&index=0&id=1a92ac5a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a92ac5a",
  null
  
)

export default component.exports